import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { AccordionDetails, AccordionSummary } from '@material-ui/core';
import React, { FC } from 'react';
import { useShopConfig } from '../../../hooks/shopConfig';
import { StyledAccordion } from '../..';
import { FAQObject } from '../../../types/shopConfig/shopConfigV2';
import { FAQDescription, FAQTitle } from '../components/FAQComponents';

export const BuyerAdditionalFAQAccordionSections: FC = () => {
  const {
    copy: { buyerAdditionalFaq },
  } = useShopConfig();

  const buildFaqNameForAnchorLink = (title: string, index: number) =>
    `${title || `buyer-additional-${index}`}`;

  return (
    <>
      {buyerAdditionalFaq.map((faq: FAQObject, index: number) => (
        <StyledAccordion
          key={buildFaqNameForAnchorLink(faq.title, index)}
          name={buildFaqNameForAnchorLink(faq.title, index)}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel10a-content"
            id="panel10a-header"
          >
            <p>
              <FAQTitle>{faq.title}</FAQTitle>
            </p>
          </AccordionSummary>
          <AccordionDetails>
            <span>
              <p>
                <FAQDescription>{faq.description}</FAQDescription>
              </p>
            </span>
          </AccordionDetails>
        </StyledAccordion>
      ))}
    </>
  );
};
